import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const ArriveDialog = ({ order, onClose, onSaved }) => {
  const open = order.lines.filter((l) => l.qty - (l.arrived || 0) > 0);
  const [q, setQ] = useState(Object.fromEntries(open.map((l) => [l.type_id, ""])));
  const [busy, setBusy] = useState(false);
  const total = Object.values(q).reduce((s, v) => s + (parseInt(v, 10) || 0), 0);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/tyres/orders/${order.id}/arrive`, { lines: open.map((l) => ({ type_id: l.type_id, qty: Math.max(0, parseInt(q[l.type_id], 10) || 0) })) });
      toast.success(`${total} gomme caricate a magazzino`); onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="tyre-arrive-dialog">
        <DialogHeader>
          <DialogTitle>Arrivo parziale · ordine {order.number}</DialogTitle>
          <DialogDescription>Scrivi quante gomme sono arrivate ora: vengono caricate a magazzino come nuove. Il resto rimane in ordine.</DialogDescription>
        </DialogHeader>
        <div className="divide-y rounded-lg border">
          {open.map((l) => {
            const left = l.qty - (l.arrived || 0);
            return (
              <div key={l.type_id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`tyre-arrive-row-${l.type_id}`}>
                <div className="min-w-0 flex-1"><p className="truncate font-medium">{l.type_label}</p>
                  <p className="text-xs text-slate-500">Ordinate {l.qty} · arrivate {l.arrived || 0} · mancano {left}</p></div>
                <Input type="number" min="0" max={left} value={q[l.type_id]} placeholder="0" className="h-8 w-20 text-right"
                  onChange={(e) => setQ({ ...q, [l.type_id]: e.target.value })} data-testid={`tyre-arrive-qty-${l.type_id}`} />
              </div>
            );
          })}
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy || total <= 0} data-testid="tyre-arrive-save">{busy ? "Salvataggio..." : `Carica ${total} gomme`}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
